module.exports = __webpack_public_path__ + "assets/img/world-map.c5cf49fc.jpg";